import styled from 'styled-components'

import { Color } from 'root-constants'

export const StyledClipboardField = {
  Container: styled.div`
    max-width: 304px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;

    background: ${Color.GOLD_LIGHTEST};
    border-radius: 8px;
    border: 2px solid ${Color.GOLD_DARKEST};

    & p {
      font-size: clamp(14px, 2.5vw, 16px);
      font-weight: 700;
      color: ${Color.GOLD_DARKEST};
      word-break: break-word;
    }

    padding: 8px 12px;
    margin: 4px 0 12px;
  `,
  Tooltip: styled.div<{ $isVisible?: boolean }>`
    position: absolute;
    top: -30px;
    inset-inline-end: 10px;

    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
    background-color: ${Color.BLACK};
    color: ${Color.GOLD_LIGHTER};

    border-radius: 4px;

    padding: 4px 8px;
    z-index: 10;

    opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
    transform: ${({ $isVisible }) =>
      $isVisible ? 'translateY(0)' : 'translateY(10px)'};
    transition:
      opacity 0.3s ease,
      transform 0.3s ease;

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      inset-inline-end: 10px;
      border-width: 5px;
      border-style: solid;
      border-color: ${Color.BLACK} transparent transparent transparent;
    }
  `,
}
